import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/message-campaigns',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::index
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:19
* @route '/admin-panel/message-campaigns'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::destroy
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:42
* @route '/admin-panel/message-campaigns/{campaign}'
*/
export const destroy = (args: { campaign: string | { id: string } } | [campaign: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/message-campaigns/{campaign}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::destroy
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:42
* @route '/admin-panel/message-campaigns/{campaign}'
*/
destroy.url = (args: { campaign: string | { id: string } } | [campaign: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return destroy.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::destroy
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:42
* @route '/admin-panel/message-campaigns/{campaign}'
*/
destroy.delete = (args: { campaign: string | { id: string } } | [campaign: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::destroy
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:42
* @route '/admin-panel/message-campaigns/{campaign}'
*/
const destroyForm = (args: { campaign: string | { id: string } } | [campaign: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\MessageCampaignsController::destroy
* @see app/Http/Controllers/AdminPanel/MessageCampaignsController.php:42
* @route '/admin-panel/message-campaigns/{campaign}'
*/
destroyForm.delete = (args: { campaign: string | { id: string } } | [campaign: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const messageCampaigns = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default messageCampaigns